module.exports = __webpack_public_path__ + "static/media/Meredith Schaefer_1697504143355.d48975c6.png";